import { useState, memo } from "react";
import { Modal, Form, InputGroup, Dropdown } from "react-bootstrap";

import { useAppSelector } from "../store/hooks";

import BubbleComponent from "./BubbleComponent";
import SearchDropdown from "./SearchDropdown";

import clickElementHandler from "../utils/clickElementHandler";
import formatUsername from "../utils/formatUsername";

import SetState from "../typings/SetState";
import Channel from "../typings/Channel";
import DashboardUser from "../typings/DashboardUser";
import useCheckText from "../hooks/use-checkText";
import ButtonComponent from "./ButtonComponent";

type NewChannelModalProp = {
  show: boolean;
  onClose: SetState<boolean>;
  onCreateChannelHandler: (
    name: string,
    description: string,
    owners: Channel["owners"]
  ) => void;
};

const NewChannelModal = ({
  show,
  onClose,
  onCreateChannelHandler,
}: NewChannelModalProp) => {
  const [coOwners, setCoOwners] = useState<Channel["owners"]>([]);
  const [channelName, setChannelName] = useState("");
  const [channelDesc, setChannelDesc] = useState("");
  const [users, setUsers] = useState<DashboardUser[]>([]);

  const { error, handleTextChange } = useCheckText(setChannelName);

  const username = useAppSelector((state) => state.auth.user.username);

  const onSubmitHandler = (e: React.SyntheticEvent) => {
    e.preventDefault();
    onCreateChannelHandler(channelName, channelDesc, coOwners);
    setChannelDesc("");
    setChannelName("");
  };

  let coOwnersBubbles = coOwners.map((user) => (
    <BubbleComponent
      key={user.username}
      onClick={() => {
        clickElementHandler(user, coOwners, setCoOwners);
      }}
    >
      {formatUsername(user.username)}
    </BubbleComponent>
  ));

  let dropdownItems = users.map((user) => {
    if (formatUsername(user.username) === username) {
      return null;
    } else {
      if (!coOwners.find((i) => i.userId === user.userId))
        return (
          <Dropdown.Item
            key={user.userId}
            onClick={() => {
              clickElementHandler(user, coOwners, setCoOwners);
            }}
          >
            {formatUsername(user.username)}
          </Dropdown.Item>
        );
      return null;
    }
  });

  return (
    <Modal show={show} onHide={() => onClose(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Create Channel</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <InputGroup>
              <InputGroup.Text>#</InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="channel's name..."
                onChange={(e) => handleTextChange(e.target.value)}
                value={channelName}
              />
            </InputGroup>
            <p className="font-weight-light">
              The hashtag is added automatically. Only letters and numbers are
              allowed.{" "}
            </p>
            <Form.Control
              type="text"
              placeholder="channels's description..."
              onChange={(e) => setChannelDesc(e.target.value)}
              value={channelDesc}
            />
            <Modal.Footer>
              {coOwnersBubbles}
              <SearchDropdown
                title="Add co-owners"
                dropdownItems={dropdownItems}
                setData={setUsers}
                fetchURL="/api/dashboardUser/findByName/"
              />
            </Modal.Footer>
          </Form.Group>

          <Modal.Footer>
            <ButtonComponent onClick={() => onClose(false)}>
              Close
            </ButtonComponent>
            <ButtonComponent
              type="submit"
              onClick={(e) => onSubmitHandler(e)}
              disabled={error || channelName.length === 0}
            >
              Submit
            </ButtonComponent>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default memo(NewChannelModal);
